"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplierService = void 0;
const typeorm_1 = require("typeorm");
// eslint-disable-next-line import/no-cycle
const Supplier_1 = require("./Supplier");
const CircularReference_1 = require("../../serialization/CircularReference");
const ServiceClass_1 = require("../../service/entity/ServiceClass");
let SupplierService = class SupplierService {
    constructor(init) {
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.SupplierService = SupplierService;
__decorate([
    (0, typeorm_1.ManyToOne)(() => ServiceClass_1.ServiceClass),
    __metadata("design:type", ServiceClass_1.ServiceClass)
], SupplierService.prototype, "serviceClass", void 0);
__decorate([
    (0, typeorm_1.RelationId)((sq) => sq.serviceClass),
    (0, typeorm_1.PrimaryColumn)(),
    __metadata("design:type", String)
], SupplierService.prototype, "serviceClassId", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => Supplier_1.Supplier, (s) => s.services),
    (0, CircularReference_1.CircularRef)(),
    __metadata("design:type", Supplier_1.Supplier)
], SupplierService.prototype, "supplier", void 0);
__decorate([
    (0, typeorm_1.RelationId)((sq) => sq.supplier),
    (0, typeorm_1.PrimaryColumn)(),
    __metadata("design:type", String)
], SupplierService.prototype, "supplierId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", String)
], SupplierService.prototype, "comment", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: 'jsonb', nullable: true }),
    __metadata("design:type", Array)
], SupplierService.prototype, "languages", void 0);
exports.SupplierService = SupplierService = __decorate([
    (0, typeorm_1.Entity)(),
    __metadata("design:paramtypes", [Object])
], SupplierService);
